import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import RadioButton from '@prism/radiobutton';

class PrismRadioButton extends React.PureComponent {
    static propTypes = {
        id: PropTypes.string,
        name: PropTypes.string,
        className: PropTypes.string,
        radiobuttonClassName: PropTypes.string,
        required: PropTypes.bool,
        label: PropTypes.string,
        checked: PropTypes.bool,
        disabled: PropTypes.bool,
        counts: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onClick: PropTypes.func,
        value: PropTypes.any
    };

    static defaultProps = {
        checked: false,
        disabled: false
    };

    onChange = (event) => {
        event.stopPropagation();
        const { checked } = event.target;

        if (this.props.onChange) {
            this.props.onChange(checked);
        }
    }

    render() {
        const {
            className,
            radiobuttonClassName,
            ...elementProps
        } = this.props;

        const containerClassName = classNames(
            'prism-sandbox',
            'prism-radiobutton-container',
            className
        );

        const elementClassName = classNames(
            'prism-radiobutton',
            radiobuttonClassName
        );

        return (
            <div className={containerClassName}>
                <RadioButton
                    {...elementProps}
                    className={elementClassName}
                    onChange={this.onChange}
                />
            </div>
        )
    }
}

export default PrismRadioButton;


